import { Component, OnInit } from '@angular/core';
import { ServiceLayer } from '../../services/serviceLayer';
declare var jQuery: any;
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  public needSupport:any;
  public bfmSupport:any;
  constructor(private serviceLayer:ServiceLayer) { }

  ngOnInit() {
    this.getUnderWriterInfo();
    var current = location.pathname;
    jQuery('.nav-item').removeClass('active');
    if(current == '/') {
      current = "landing";
    }
    else {
      jQuery('.' + current.replace('/','')).addClass('active')
    }
  }
  toggleMenu(type){
    if(type != undefined && type != ''){
      jQuery('.nav-item').removeClass('active');
      jQuery('.' + type).addClass('active') 
    }        
  }

  getUnderWriterInfo(){
    this.needSupport = JSON.parse(window.localStorage.getItem("UnderWriterInfo"));
    if(this.needSupport != undefined && this.needSupport.bfmSupportInformation != undefined && this.needSupport.bfmSupportInformation.length>0) {
        this.bfmSupport = this.needSupport.bfmSupportInformation.filter(data=>data.name == "Berklwy Fire & Marine Support");
        if(this.bfmSupport.length>0) {
          this.bfmSupport = this.bfmSupport[0];
        }
    }
  }

  policy(policytype) {
    if(policytype != undefined && policytype == 'Cancel My Policy') {
      window.localStorage.setItem("policyType", "Cancel My Policy");
    }
    else if(policytype != undefined && policytype == 'Manage a Policy') {
      window.localStorage.setItem("policyType", "Manage a Policy");
    }
    window.localStorage.setItem("currentPolicy","");
  }
}
